import { createApp } from 'vue'
import App from './EnvironmentCircular.vue'

createApp(App).mount('#app-environment-circular')
